import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod } from "theme";

let _abortController,
	_LinePropertyGHD_instances;

var LinePropertyGHD = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _LinePropertyGHD_instances);
    __privateAdd(this, _abortController);
	
  }
  connectedCallback() {
      if (!this.dependancyElement) {
        throw "Dependancy component requires object.";
      }
	  __privateSet(this, _abortController, new AbortController());
      this.dependancyElement.addEventListener("change", (event) => this.onSelectChange(event), { signal: __privateGet(this, _abortController).signal });
  }
  
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
  
  get dependancyElementParent() {
    return document.getElementById(this.getAttribute("dependancy-id"));
  }
  
  get dependancyValues() {
	  const raw = this.getAttribute("dependancy-values");
	  return raw ? raw.split(",").map(val => val.trim()) : [];
  }
  
  get dependancyElement() {
    return this.dependancyElementParent.querySelector('select');
  }
  
  get selectElement() {
    return this.querySelector('select');
  }
  
  onSelectChange(event) {
    const newValue = event.target.value;
    const allowedValues = this.dependancyValues;

    if (allowedValues.includes(newValue)) {
      // Show this element
      this.classList.remove('hidden');

      // Enable the <select> element
      this.selectElement.removeAttribute('disabled');
    } else {
      // Optionally hide/disable if value is not allowed
      this.classList.add('hidden');
      this.selectElement.setAttribute('disabled', '');
    }
  }
};

_abortController = new WeakMap();
_LinePropertyGHD_instances = new WeakSet();

if (!window.customElements.get("line-property-ghd")) {
  window.customElements.define("line-property-ghd", LinePropertyGHD);
}

export {
	LinePropertyGHD
};